module.exports = __webpack_public_path__ + "static/media/tense-nervous.53968023.png";